var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"location-search-results__heading"},[_vm._v("\n  "+_vm._s(_vm.count)+" Locations Found\n")])}
var staticRenderFns = []

export { render, staticRenderFns }